// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submenu[data-v-056984a8] {\n  left: 100%;\n}\n.menu[data-v-056984a8] {\n  top: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
